import React from "react";
import {useSelector} from "react-redux";
import SingleInfoSection from "./singleInfoSection";
import ManagingInfoSection from "./ManagingInfoSection";
import ComponentHeader from "../CommonComponents/componentHeader";
import {eachWordStartWithCapital} from "../../Util/dataHelper";
import PasswordUpdateSection from "./passwordUpdateSection";
import BillingInformationUpdate from "./billingInfoUpdate";
import { useFetchCompanyInfosQuery } from "../../Apis/companyApi";
import { enterpriseDetailsSelector } from "../../Reducers/enterpriseDetailsReducer";
import { enterpriseLevelsDetailsSelector } from "../../Reducers/enterpriseLevelsDetailsReducer";

const PROFILE_COMPONENT = "PROFILE_COMPONENT";
const BASE_SIGNUP_URL = "https://dispatch.shipday.com/signUp?pref=";

const ProfilePageWrapper = () => {
    const enterpriseAdminDetails = useSelector(enterpriseDetailsSelector);
    const enterpriseLevelsDetails = useSelector(enterpriseLevelsDetailsSelector);
    const { data: enterpriseCompanyAccounts } = useFetchCompanyInfosQuery();
    const count = enterpriseLevelsDetails.getRegionAndSubRegionCounts();
    const managingText = `${count[0]} Region(s), ${count[1]} Subregion(s) and ${enterpriseCompanyAccounts?.getAccountsArray().length ?? 0} Companies`
    if (enterpriseAdminDetails === null || !enterpriseCompanyAccounts)
        return <></>

    return (
        <>
            <ComponentHeader title="Profile"/>
            <div className="mx-auto d-flex justify-content-center" style={{paddingLeft: "8px", paddingRight: "8px"}}>
                <div className="profile-div">
                    <span className="sub-title">Personal Information</span>
                    <div className="mt-2 mb-3 info-container lh-lg">
                        <SingleInfoSection label={"Name"} info={enterpriseAdminDetails.name}/>
                        <SingleInfoSection label={"Address:"} info={enterpriseAdminDetails.address}/>
                        <SingleInfoSection label={"Email:"} info={enterpriseAdminDetails.email}/>
                        <SingleInfoSection label={"Administrator Level:"}
                                           info={eachWordStartWithCapital(enterpriseAdminDetails.administratorLevel)}/>
                        <ManagingInfoSection managingText={managingText}/>
                    </div>
                    <PasswordUpdateSection/>
                    <BillingInformationUpdate/>
                </div>
            </div>
        </>
    )
}

export default ProfilePageWrapper;
export {PROFILE_COMPONENT};
